import * as mojs from "mo-js";

export function init() {
	const CIRCLE_RADIUS = 35;
	const circle = new mojs.Shape({
		left: 0,
		top: 0,
		stroke: '#f4f5f5', // gray-lighter
		strokeWidth: {[CIRCLE_RADIUS * 1.25]: 0},
		fill: 'none',
		scale: {0: 1},
		opacity: {1: 0},
		radius: CIRCLE_RADIUS,
		duration: 800,
		easing: 'cubic.out'
	});

	$('.js-bubble-tooltip').on('click', function (e) {
		e.preventDefault();

		// Close other open tooltips
		$('.js-tooltip-contents').removeClass('state-visible');

		$(this).closest('.bubble-tooltip').find('.js-tooltip-contents').toggleClass('state-visible');
	}).on('mouseenter', function (e) {
		let $this = $(this);
		let pos = $this.offset();
		let coords = {x: pos.left + $this.outerWidth(true) / 2, y: pos.top + 20};

		circle.tune(coords).replay();
	});

	$('.js-bubble-tooltip-close').on('click', function (e) {
		$(this).closest('.js-tooltip-contents').removeClass('state-visible');
		e.preventDefault();
	});
}
